// 🎨 Furbook App Settings
// ไฟล์ตั้งค่าต่างๆ สำหรับ Furbook

export const appSettings = {
  // 🌄 Background Image Settings
  backgroundImage: {
    // URL ของรูปพื้นหลังหน้าหลัก (ใส่ URL รูปที่ต้องการ)
    homePageUrl: "https://scontent.fbkk6-2.fna.fbcdn.net/v/t39.30808-6/500950332_10160780776612133_8039071401266124864_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeFfKhBgLWur-E0_9bLrtaPmV3aRZxWVPfdXdpFnFZU99_NK3vKgn6oe5EX-d6gXOM4&_nc_ohc=xyzx6CoB1iAQ7kNvwHXsipy&_nc_oc=AdmtDefs6Xd7wioMuGxPqHuhU-nRKt0BklBqFF9kiAX_WwivFBSM6w5874O-S1gm61I&_nc_zt=23&_nc_ht=scontent.fbkk6-2.fna&_nc_gid=7EZNmicRBI_HNuJlmXAT4Q&oh=00_AfI73VNH05iYK66cTG69IZMdMfP65Dhw-aOHxdiLS2HlVg&oe=68437864",
    
    // ตัวเลือกอื่นๆ สำหรับ background image
    opacity: 1.0,              // ความโปร่งใสของรูป (0.0 - 1.0)
    blur: false,               // เบลอรูปพื้นหลังหรือไม่
    position: "center",        // ตำแหน่งรูป: center, top, bottom, left, right
    size: "cover",             // ขนาดรูป: cover, contain, auto
    repeat: "no-repeat",       // การทำซ้ำ: no-repeat, repeat, repeat-x, repeat-y
    
    // Alternative URLs (สำรอง)
    alternatives: [
      "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80",
      "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1469&q=80",
      "https://images.unsplash.com/photo-1574144611937-0df059b5ef3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1364&q=80"
    ]
  },

  // 🎨 Theme Settings
  theme: {
    // โหมดธีม
    mode: "auto",             // light, dark, auto
    
    // การปรับแต่งสี (override default Furbook colors)
    colorOverrides: {
      // primary: "#8D6748",     // สามารถ override สีได้ที่นี่
      // secondary: "#F1E7DC",
      // accent1: "#FFCEDB",
      // accent2: "#F98A0C"
    }
  },

  // 📱 UI Settings
  ui: {
    // การแสดงผล
    showBackgroundImage: true,  // เปิด/ปิดการแสดง background image
    showHeroContent: false,      // เปิด/ปิดการแสดง hero section ✨ NEW
    showWelcomeMessage: false,   // เปิด/ปิด welcome banner ✨ NEW
    compactMode: false,         // โหมดกะทัดรัด
    roundedCorners: true,       // มุมโค้ง
    animations: true,           // แอนิเมชัน
    
    // การตั้งค่าอื่นๆ
    defaultAnimalView: "grid",  // grid, list
    postsPerPage: 10,           // จำนวนโพสต์ต่อหน้า
  },

  // 🗺️ Map Settings
  map: {
    defaultZoom: 13,
    defaultCenter: [13.7563, 100.5018], // Bangkok coordinates
    searchRadius: 5 // km
  },

  // 📝 Content Settings
  content: {
    // ข้อความต้อนรับ
    welcomeMessage: "🐾 ยินดีต้อนรับสู่ TailLink - ชุมชนคนรักสัตว์ที่อบอุ่น",
    
    // ข้อความ subtitle
    subtitle: "เชื่อมต่อกับสัตว์เลี้ยง ช่วยเหลือสัตว์จรจัด และสร้างชุมชนที่เอาใจใส่ผ่าน TailLink",
    
    // placeholders
    placeholders: {
      search: "🔍 ค้นหาน้องๆ ในบริเวณใกล้เคียง...",
      postContent: "แชร์เรื่องราวเกี่ยวกับน้องๆ...",
      animalName: "ชื่อของน้อง",
      animalDescription: "เล่าเรื่องราวเกี่ยวกับน้อง..."
    }
  },

  // 🔧 Advanced Settings
  advanced: {
    // Performance
    enableLazyLoading: true,
    imageOptimization: true,
    
    // Debug
    debugMode: false,
    showConsoleInfo: false
  }
};

// ฟังก์ชันสำหรับดึงการตั้งค่า
export const getSetting = (path, defaultValue = null) => {
  const keys = path.split('.');
  let result = appSettings;
  
  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return defaultValue;
    }
  }
  
  return result;
};

// ฟังก์ชันสำหรับอัปเดตการตั้งค่า (สำหรับอนาคต)
export const updateSetting = (path, value) => {
  const keys = path.split('.');
  let current = appSettings;
  
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!(key in current) || typeof current[key] !== 'object') {
      current[key] = {};
    }
    current = current[key];
  }
  
  current[keys[keys.length - 1]] = value;
};

// Export default
export default appSettings;